// src/components/ProductsReports.js

import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TablePagination,
  TextField, Button, Paper, Dialog, DialogTitle, DialogContent, Typography
} from '@mui/material';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function ProductsReports() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    axios.get('https://vyaparapi.emedha.in/api/admin/products') // your API endpoint
      .then(res => setProducts(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleExport = () => {
    const exportData = products.map(({ user_id, ...rest }) => rest); // exclude user_id
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(file, "Products_Report.xlsx");
  };

  const filtered = products.filter((product) =>
    product.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleOpenModal = (product) => setSelectedProduct(product);
  const handleCloseModal = () => setSelectedProduct(null);

  return (
    <div style={{ padding: 20 }}>
      <h3>📦 Products Reports</h3>

      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <TextField
          label="Search by Product Name"
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button variant="contained" color="primary" onClick={handleExport}>
          📤 Export Excel
        </Button>
      </div>

      <Paper>
        <TableContainer>
          <Table>
            <TableHead style={{ backgroundColor: "#1976d2" }}>
              <TableRow>
                <TableCell style={{ color: "#fff" }}>#</TableCell>
                <TableCell style={{ color: "#fff" }}>Product Name</TableCell>
                <TableCell style={{ color: "#fff" }}>Category</TableCell>
                <TableCell style={{ color: "#fff" }}>Price</TableCell>
                <TableCell style={{ color: "#fff" }}>Validity</TableCell>
                <TableCell style={{ color: "#fff" }}>Seller</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, idx) => (
                <TableRow key={row.id}>
                  <TableCell>{idx + 1 + (page * rowsPerPage)}</TableCell>
                  <TableCell>
                    <span style={{ color: "#1976d2", cursor: 'pointer' }} onClick={() => handleOpenModal(row)}>
                      {row.name}
                    </span>
                  </TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>₹{row.price}</TableCell>
                  <TableCell>{row.validity}</TableCell>
                  <TableCell>{row.user_name}</TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">No data found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={filtered.length}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {/* Modal for Product Detail */}
      <Dialog open={Boolean(selectedProduct)} onClose={handleCloseModal} fullWidth maxWidth="md">
        <DialogTitle>📝 Product Detail</DialogTitle>
        <DialogContent dividers>
          {selectedProduct && (
            <>
              <Typography><strong>Name:</strong> {selectedProduct.name}</Typography>
              <Typography><strong>Category:</strong> {selectedProduct.category}</Typography>
              <Typography><strong>Price:</strong> ₹{selectedProduct.price}</Typography>
              <Typography><strong>Warranty:</strong> {selectedProduct.warranty}</Typography>
              <Typography><strong>Validity:</strong> {selectedProduct.validity}</Typography>
              <Typography><strong>Specifications:</strong><br />{selectedProduct.specifications}</Typography>
              <Typography><strong>Seller:</strong> {selectedProduct.user_name} ({selectedProduct.user_email})</Typography>
              <Typography><strong>Location:</strong> {selectedProduct.city}, {selectedProduct.state}</Typography>
              <img src={selectedProduct.image} alt="product" style={{ width: 250, marginTop: 10 }} />
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
